import { makeStyles } from '@mui/styles';
import { colors, typography as typographyTokens } from '@components/design-system/tokens';

export const useStyles = makeStyles((theme: any) => ({
    appBar: {
        position: 'relative !important' as any,
        height: '72px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: colors.neutral[0],
        boxShadow: 'none',
        borderBottom: `1px solid ${colors.neutral[200]}`,
        flexShrink: 0,

        [theme.breakpoints.down('md')]: {
            height: '60px',
        },
    },
    appToolbar: {
        padding: '0 24px',
        flex: 1,
        minHeight: 'unset !important',
        gap: 24,

        [theme.breakpoints.down('md')]: {
            padding: '0 12px',
            justifyContent: 'space-between',
            gap: 12,
        },
    },
    logo: {
        height: '32px',
        display: 'block',

        [theme.breakpoints.down('md')]: {
            height: '28px',
        },
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
}));
